import { render } from "./SortedMultiselect.vue?vue&type=template&id=5573e1a5"
import script from "./SortedMultiselect.vue?vue&type=script&lang=js"
export * from "./SortedMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__